import { render, staticRenderFns } from "./ManagerTableActions.vue?vue&type=template&id=4c7585c9&"
import script from "./ManagerTableActions.vue?vue&type=script&lang=js&"
export * from "./ManagerTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports